import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	errorHeading: {
		id: 'fastshift.dashboard.summary-section-card.error-heading',
		defaultMessage: 'An Error Occurred',
		description: 'Error heading for the summary section card',
	},
	refreshPage: {
		id: 'fastshift.dashboard.summary-section-card.refresh-page-link',
		defaultMessage: 'Refresh the page',
		description: 'Refresh page link for the summary section card',
	},
	refresh: {
		id: 'fastshift.dashboard.summary-section-card.refresh',
		defaultMessage: 'Refresh',
		description: 'Refresh data for the summary section card',
	},
});
